import devtools from "devtools-detect";

// Utility functions for exam security

// Disable right-click context menu
//commented out for testing
// export const disableContextMenu = () => {
//   document.addEventListener("contextmenu", (e) => {
//     e.preventDefault();
//     return false;
//   });
// };

// Disable copy, cut, paste
export const disableCopyPaste = () => {
  document.addEventListener("copy", (e) => {
    e.preventDefault();
    return false;
  });

  document.addEventListener("cut", (e) => {
    e.preventDefault();
    return false;
  });

  document.addEventListener("paste", (e) => {
    e.preventDefault();
    return false;
  });

  // Disable text selection
  document.addEventListener("selectstart", (e) => {
    e.preventDefault();
    return false;
  });
};

// Fullscreen management
export const requestFullscreen = async () => {
  try {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      await elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      await elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      await elem.msRequestFullscreen();
    }
    return true;
  } catch (error) {
    console.error("Error requesting fullscreen:", error);
    return false;
  }
};

// Check if currently in fullscreen
export const isInFullscreen = () => {
  return !!(
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement
  );
};

// Monitor fullscreen changes
export const initializeFullscreenMonitoring = (onFullscreenExit) => {
  document.addEventListener("fullscreenchange", () => {
    if (!document.fullscreenElement) {
      onFullscreenExit();
    }
  });

  document.addEventListener("webkitfullscreenchange", () => {
    if (!document.webkitFullscreenElement) {
      onFullscreenExit();
    }
  });

  document.addEventListener("mozfullscreenchange", () => {
    if (!document.mozFullScreenElement) {
      onFullscreenExit();
    }
  });

  document.addEventListener("MSFullscreenChange", () => {
    if (!document.msFullscreenElement) {
      onFullscreenExit();
    }
  });
};

// Disable keyboard shortcuts
export const disableKeyboardShortcuts = () => {
  document.addEventListener("keydown", (e) => {
    // Prevent Ctrl+C, Ctrl+V, Ctrl+X
    if (e.ctrlKey && (e.key === "c" || e.key === "v" || e.key === "x")) {
      e.preventDefault();
      return false;
    }

    // Comment out DevTools keyboard shortcuts for testing
    /* 
    // Prevent F12 (Developer Tools)
    if (e.key === "F12") {
      e.preventDefault();
      return false;
    }

    // Prevent Ctrl+Shift+I (Developer Tools)
    if (e.ctrlKey && e.shiftKey && e.key === "I") {
      e.preventDefault();
      return false;
    }

    // Prevent Ctrl+Shift+C (Developer Tools)
    if (e.ctrlKey && e.shiftKey && e.key === "C") {
      e.preventDefault();
      return false;
    }

    // Prevent Ctrl+U (View Source)
    if (e.ctrlKey && e.key === "u") {
      e.preventDefault();
      return false;
    }
    */
  });
};

// Initialize all security measures
export const initializeSecurityMeasures = () => {
  // disableContextMenu();
  disableCopyPaste();
  disableKeyboardShortcuts();

  // Comment out DevTools detection for testing
  /*
  // Monitor for DevTools using devtools-detect
  window.addEventListener("devtoolschange", function (e) {
    if (e.detail.isOpen) {
      console.warn("Developer Tools detected!");
      // You can add additional actions here, such as:
      // - Logging the incident
      // - Showing a warning dialog
      // - Notifying a proctor
      // - Taking a screenshot
    }
  });

  // Check initial DevTools state
  if (devtools.isOpen) {
    console.warn("Developer Tools was already open!");
  }
  */
};
